export default "__VITE_PUBLIC_ASSET__865ef0d3__"